// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2944":"5a8a880d","6533":"5fccd88b"}[chunkId] + ".chunk.css";
};